module.exports = __webpack_public_path__ + "media/images/flags/1x1/grc-3b3a748b7f2e67a3deea8e3f8c5a7597.svg";